export const ROLES = Object.freeze({
  ROLE_SUPER_ADMIN: 'Super Admin',
  ROLE_AREA_ADMIN: 'Area Admin',
  ROLE_ADMIN: 'Admin',
  ROLE_USER: 'User'
});

export const ROLE = Object.keys(ROLES);

export const BRACKET_MATERIALS = Object.freeze({
  STEEL: 'Steel',
  COPPER: 'Copper',
  ALUMINUM: 'Aluminum',
  ROW_STEEL: 'Raw Steel',
  ZINC_PLATED_STEEL: 'Zinc Plated Steel',
  POWDER_COATED_STEEL: 'Powder Coated Steel'
});

export const SYSTEM_COMPONENT_TYPES = Object.freeze({
  COLLAR: 'Collar',
  COUPLING: 'Coupling/Union',
  PIPE: 'Pipe',
  STOP_END: 'End Caps',
  ICE_FLAG: 'Ice Flags'
});

export const TIERS = Object.freeze({
  TIER1: 'Tier 1',
  TIER2: 'Tier 2',
  TIER3: 'Tier 3',
  TIER4: 'Tier 4',
  TIER5: 'Tier 5'
});
